import './SignUp.scss';
import Component from './SignUp.js';
export default Component;
